module.exports = __webpack_public_path__ + "static/add_google_account-b8339d6b1b2302e26661e6b94e5cc1e8.png";